import resultFactory from '~/utils/resultFactory'

/**
 @since 2021-12-03
 @author Jaeuk Ryu <wj_tams_dev02>
 */

export const state = () => ({
  SamlSettingUrl: '/api/sm/auth/saml-cm', // SAML 설정 URL
  SamlSyncUrl: '/api/sm/auth/saml-cm/sync', // SAML 사용여부 설정 URL
  SamlUrl: '/api/sm/auth', // SAML URL
  defaultId: -1, // 설정 추가용 ID
  settingDataList: [], // 설정 데이터 리스트
  authServerDataList: [], // SAML 조회 리스트

  // samldServerResult: 'OK', // 서버 추가시 중복 테스트 용도
  selectedStoreItem: {}, // 수정중인 항목 모든탭 동일
  metaData: []
})

export const mutations = {
  clearStore: (state) => {
    state.defaultId = -1
    state.settingDataList = [] // 설정 데이터 리스트
    state.authServerDataList = [] // SAML 조회 리스트
    state.selectedStoreItem = []
    state.metaData = []
  },
  clearServerDataList: (state) => {
    state.authServerDataList = [] // SAML 조회 리스트
  },
  getDefaultId: (state, data) => {
    state.defaultId = data.authsvr_saml_cm_id
  },

  // 서버 Reference 조회
  // getServerReference: (state, item) => { // need to check
  //   // state.serverReference = item
  //   let serverRef = _.clone(state.serverReference)
  //   const keys = Object.keys(state.serverReference)
  //   _.forEach(keys, key => {
  //     if (item[key]) {
  //       serverRef[key] = item[key]
  //     } else {
  //       serverRef[key] = []
  //     }
  //   })
  //   state.serverReference = serverRef
  // },

  setSelectedStoreItem: (state, item) => {
    state.selectedStoreItem = item
  },
  getSettingDataList: (state, item) => {
    state.settingDataList = _.cloneDeep(item)
  },

  editAuthServerListDataAction: (state, data) => {
    state.settingDataList = _.map(state.settingDataList, (item) => {
      if (item.authsvr_saml_cm_id === data.authsvr_saml_cm_id) {
        item = _.cloneDeep(data)
        // item.protocolName = getProtocolName(item)
      }
      return item
    })
  },

  authServerHeaderMutation: (state, data) => {
    state.settingDataList = _.map(state.settingDataList, (item) => {
      item.authsvr_saml_cm_sync_yn = data
      return item
    })
  },

  delSettingDataList: (state, item) => {
    _.forEach(item, (p) => {
      const idx = _.findIndex(state.settingDataList, {authsvr_saml_cm_id: p.authsvr_saml_cm_id})
      if (idx >= 0) {
        state.settingDataList.splice(idx, 1)
      }
    })
  },

  getSamlDataList: (state, item) => {
    state.authServerDataList = _.cloneDeep(item)
  },
  addSamlData: (state, item) => {
    state.authServerDataList.push(_.cloneDeep(item))
  },
  editSamlData: (state, item) => {
    const idx = _.findIndex(state.authServerDataList, {authsvr_saml_id: item.authsvr_saml_id})
    state.authServerDataList.splice(idx, 1, item)
  },
  delSamlDataList: (state, item) => {
    _.forEach(item, (p) => {
      const idx = _.findIndex(state.authServerDataList, {authsvr_saml_id: p.authsvr_saml_id})
      if (idx >= 0) {
        state.authServerDataList.splice(idx, 1)
      }
    })
  },
  metaDataFileUpload: (state, item) => {
    state.metaData = _.cloneDeep(item)
  }
}

export const actions = {
  async getSettingDataList ({commit, state}) { // 인증 서버 설정 조회
    try {
      const data = await this.$axios.$get(state.SamlSettingUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getSettingDataList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async addSettingData ({commit, state}, payload) { // 인증 서버 통합 설정 추가 인증 서버 추가.
    try {
      const data = await this.$axios.$put(state.SamlSettingUrl, payload, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editSettingData ({commit, state}, payload) { // 인증 서버 통합 편집
    try {
      const data = await this.$axios.$put(state.SamlSettingUrl, payload, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delSettingDataList ({commit, state}, payload) {
    let isMulty = false
    const idList = []
    const delList = []
    if (payload.length > 1) {
      isMulty = true
    }
    payload.forEach((item) => {
      idList.push({'authsvr_saml_cm_id': item.authsvr_saml_cm_id})
      delList.push(item.authsvr_saml_cm_id)
    })
    try {
      const data = isMulty ? await this.$axios.$delete(state.SamlSettingUrl, {data: {items: delList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.SamlSettingUrl}/${payload[0].authsvr_saml_cm_id}`)

      return resultFactory(commit, {length: idList.length, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },

  async editAuthServerDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(state.SamlSyncUrl, payload, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editAuthServerListDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(`${state.SamlSyncUrl}/${payload[0].authsvr_saml_cm_id}`, _.pick(payload[0], ['authsvr_saml_cm_sync_yn']), {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },

  async getDefaultId ({commit, state}) { // 설정 추가용 ID 조회
    try {
      const data = await this.$axios.$post(state.SamlSettingUrl, null, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getDefaultId', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // SAML //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getSamlDataList ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.SamlUrl}/${state.defaultId}/saml`)
      return resultFactory(commit, {length: null, data: data, action: 'getSamlDataList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async addSamlData ({commit, state, dispatch}, payload) { // 인증 서버 추가.
    const param = makePayload(_.cloneDeep(payload), 'add')
    try {
      const data = await this.$axios.$post(`${state.SamlUrl}/${state.defaultId}/saml`, param)
      return resultFactory(commit, {length: null, data: data, action: 'addSamlData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editSamlData ({commit, state, dispatch}, payload) {
    const param = makePayload(_.cloneDeep(payload), 'edit')
    try {
      const data = await this.$axios.$put(`${state.SamlUrl}/${state.defaultId}/saml/${payload.authsvr_saml_id}`, param)
      return resultFactory(commit, {length: null, data: data, action: 'editSamlData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delSamlDataList ({commit, state}, payload) {
    let isMulty = false
    const idList = []
    const delList = []
    if (payload.length > 1) {
      isMulty = true
    }
    payload.forEach((item) => {
      idList.push({'authsvr_saml_id': item.authsvr_saml_id})
      delList.push(item.authsvr_saml_id)
    })
    try {
      const data = isMulty ? await this.$axios.$delete(`${state.SamlUrl}/${state.defaultId}/saml`, {data: {items: delList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.SamlUrl}/${state.defaultId}/saml/${payload[0].authsvr_saml_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: 'delSamlDataList', param: idList})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async metaDataFileUpload ({commit, state}, file) {
    const fd = new FormData()
    fd.append('authsvr_saml_cm_id', state.defaultId)
    fd.append('authsvr_saml_import_file', file)
    try {
      const data = await this.$axios.$post(`${state.SamlUrl}/${state.defaultId}/saml/metadata`, fd, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'metaDataFileUpload', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async idPAuthFileUpload ({commit, state}, file) {
    const fd = new FormData()
    fd.append('file', file)
    const res = {code: '', result: {}}
    try {
      const {code, result} = await this.$axios.$post('/api/co/gui/file/import', fd, {successAlert: false})
      _.set(res, 'code', code)
      _.set(res, 'result', result)
    } catch (e) {}

    if (res.code === 'ok') {
      return res.result.file
    }
    return ''
  }
  // SAML //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}

function makePayload (param, type) {
  const payloadKeyMap = {
    // authsvr_saml_id: 'authsvr_saml_id',
    name: 'authsvr_saml_name',
    setup_type: 'authsvr_saml_setup_type',
    entity_id: 'authsvr_saml_entity_id',
    sso_url: 'authsvr_saml_sso_url',
    single_logout_use: 'authsvr_saml_single_logout_use',
    slo_url: 'authsvr_saml_slo_url',
    user_id_property: 'authsvr_saml_user_id_property',
    idp_crt: 'authsvr_saml_idp_crt', // 인증서 파일명
    idp_crt_file: 'authsvr_saml_idp_crt_file', // 인증서 파일
    desc: 'authsvr_saml_desc',
    is_crt_upload: 'authsvr_saml_is_crt_upload'
  }
  const fd = new FormData()
  const payload = _.omit(_.mapKeys(param, (value, key) => {
    return payloadKeyMap[key]
  }), ['undefined'])

  // EDIT CASE
  if (type === 'edit') {
    return payload
  }
  // ADD CASE
  _.mapKeys(payload, (value, key) => {
    if (key === 'authsvr_saml_idp_crt_file') {
      if (payload.authsvr_saml_setup_type === 1) {
        fd.append(key, value)
      }
    } else if (key === 'authsvr_saml_slo_url') {
      if (payload.authsvr_saml_single_logout_use === 1) {
        fd.append(key, value)
      }
    } else {
      fd.append(key, value)
    }
  })
  return fd
}
